jQuery(document).ready(function () {
  $(".home-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    vertical: false,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  jQuery(".bestseller-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1499, settings: { slidesToShow: 4 } },
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  });
  jQuery(".recomm-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1499, settings: { slidesToShow: 3 } },
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  });
  jQuery(".shopby-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: "unslick" },
    ],
  });
  jQuery(".voice-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  });
  jQuery(".blog-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1, dots: false, arrows: true } },
    ],
  });
  jQuery(".review-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  });
  jQuery(".store-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 6 } },
      { breakpoint: 1199, settings: { slidesToShow: 4 } },
      { breakpoint: 767, settings: "unslick" },
    ],
  });
  jQuery(".ask-card").click(function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
    } else {
      jQuery(".ask-card").removeClass("active");
      jQuery(this).addClass("active");
    }
  });
  jQuery(".bestseller-tab li a").on("click", function () {
    var target = jQuery(this).attr("data-rel");
    jQuery(".bestseller-tab li a").removeClass("active");
    jQuery(this).addClass("active");
    jQuery("#" + target).fadeIn("slow").siblings(".bestseller-main").hide();
    jQuery(".bestseller-slider").slick("setPosition");
    return false;
  });
  jQuery(".product-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    asNavFor: ".product-nav-slider",
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 1, dots: true } },
    ],
  });
  jQuery(".product-nav-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: false,
    asNavFor: ".product-slider",
    dots: false,
    arrows: false,
    infinite: false,
    vertical: false,
    focusOnSelect: true,
    responsive: [
      { breakpoint: 479, settings: { dots: false, slidesToShow: 3, slidesToScroll: 1 } },
    ],
  });
  jQuery(".account-left-top").click(function () {
    jQuery(".account-left").toggleClass("accountactive");
  });
  if (window.matchMedia("(max-width: 1199px)").matches) {
    jQuery(".nav-item .arrow").click(function () {
      jQuery(this).parent(".nav-item").toggleClass("active").siblings().removeClass("active");
    });
    jQuery(".sidebar-togle-wraper").click(function () {
      jQuery(".layer-bg").toggleClass("active");
      jQuery(".header").toggleClass("active");
      jQuery("body").toggleClass("overflow-hiiden");
    });
    jQuery(".search-icon").click(function () {
      jQuery(".header-search").addClass("active");
      jQuery(".header").removeClass("active");
    });
    jQuery(".search-box .close").click(function () {
      jQuery(".header-search").removeClass("active");
    });
  }
  if (window.matchMedia("(max-width: 991px)").matches) {
    jQuery(".still-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{ breakpoint: 767, settings: "unslick" }],
    });
    jQuery(".moment-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 1, dots: true, arrows: true } },
      ],
    });
    jQuery(".f-colm .kurlonxsheading").click(function () {
      if (jQuery(this).hasClass("in")) {
        jQuery(this).removeClass("in");
        jQuery(this).siblings(".ftr-content").slideUp();
      } else {
        jQuery(".f-colm .kurlonxsheading").removeClass("in");
        jQuery(".ftr-content").slideUp();
        jQuery(this).addClass("in");
        jQuery(this).siblings(".ftr-content").slideDown();
      }
    });
  }
});

$(document).ready(function () {
  if (window.location.pathname.includes('/products/aaram')) {
    $('.custom-size').closest('li').remove();
  }
  jQuery(".journey-slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { dots: true, slidesToShow: 1 } },
    ],
  });
  jQuery(".innovation-slider").slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    loop: true,
    vertical: true,
    asNavFor: ".innovation-nav",
  });
  jQuery(".innovation-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: false,
    asNavFor: ".innovation-slider",
    dots: false,
    arrows: false,
    infinite: true,
    loop: true,
    vertical: true,
    focusOnSelect: true,
  });
  jQuery(".awards-slider").slick({
    dots: false,
    arrows: false,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 1 } },
    ],
  });
  $(".lifeat-slider").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { dots: true, arrows: false, slidesToShow: 2 } },
    ],
  });
  $(".meet-slider").slick({
    dots: false,
    arrows: true,
    variableWidth: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { dots: true, variableWidth: false, slidesToShow: 1 } },
    ],
  });
  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".ourvalue-right").slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  jQuery(".release-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 3 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { dots: true, slidesToShow: 1 } },
    ],
  });
});

$(".mobile-dropdowen_investor").click(function () {
  $(".tab-menu-list_investor").toggleClass("active");
});

$(".tab_link_inner").click(function () {
  var textToPaste = $(this).text();
  $(".select_investor_text").text(textToPaste);
  $(".tab-menu-list_investor").removeClass("active");
});

document.addEventListener("DOMContentLoaded", function () {
  const caseTabLinks = document.querySelectorAll(".tab-link");
  const caseCards = document.querySelectorAll(".tab-output-box_investor");
  if (caseTabLinks) {
    caseTabLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        const targetId = this.getAttribute("id");
        caseCards.forEach(function (card) {
          const cardTarget = card.getAttribute("data-case-target");
          if (targetId == "all-pdf") {
            card.classList.add("show");
          } else if (cardTarget == targetId) {
            card.classList.add("show");
          } else {
            card.classList.remove("show");
          }
        });
        caseTabLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const bannerImg = document.querySelector(".home-banner img");
  if (!bannerImg) return;
  const skeleton = document.querySelector(".skeleton");
  const realBanner = document.querySelector(".real-banner");
  if (bannerImg.complete) {
    showBanner();
  } else {
    bannerImg.onload = () => showBanner();
  }
  function showBanner() {
    if (skeleton) skeleton.style.display = "none";
    if (realBanner) realBanner.style.opacity = 1;
  }
});

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

/* ══════════════════════════════════════
   DIMENSION PRESERVE
══════════════════════════════════════ */
var savedDimension = null;

window.addEventListener('load', function () {
  var dimensionSelect = document.querySelector('#dimensions-dropdown select');
  if (dimensionSelect) {
    savedDimension = dimensionSelect.value;
    dimensionSelect.addEventListener('change', function () {
      savedDimension = this.value;
    });
  }
});

function outputDimensions(size) {
  var variantMaster = window.variantMaster;
  if (variantMaster[size]) {
    var options = '';
    var values = [];
    variantMaster[size].forEach(function (v) {
      if (!values.includes(v?.option3?.toLowerCase())) {
        options += `<option value="${v.option3}">${v.option3}</option>`;
      }
      values.push(v?.option3?.toLowerCase());
    });
    var dimSel = document.querySelector('[name="option3"]');
    dimSel.innerHTML = options;

    if (savedDimension) {
      var found = false;
      dimSel.querySelectorAll('option').forEach(function (opt) {
        var optClean = opt.value.toLowerCase().replace(/\s/g, '').replace(/inch/g, '');
        var savedClean = savedDimension.toLowerCase().replace(/\s/g, '').replace(/inch/g, '');
        if (optClean === savedClean) {
          dimSel.value = opt.value;
          found = true;
        }
      });
      if (!found) {
        savedDimension = dimSel.options[0] ? dimSel.options[0].value : null;
      }
    }
  }
}

function changeVariantValues(e, handle) {
  var dimensionSelect = document.querySelector('#dimensions-dropdown select');
  if (dimensionSelect && dimensionSelect.value) {
    savedDimension = dimensionSelect.value;
  }

  const selectedInputs = Array.from(document.querySelectorAll('#variant-selectors label')).map(fieldset => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });

  selectedInputs.forEach(function (value) {
    var lowerVal = value?.toLowerCase();
    if (lowerVal == 'single' || lowerVal == 'double' || lowerVal == 'king' || lowerVal == 'queen') {
      outputDimensions(value);
      console.log('it works changeVariantValues', value);
    }
  });

  changeVariant(e, handle);
}

function changeVariant(e, handle) {
  var customLength = document.querySelector(customLengthElement);
  var customBreadth = document.querySelector(customBreadthElement);
  var customThickness = document.querySelector(customThicknessElement);

  if (customLength) customLength.value = '';
  if (customBreadth) customBreadth.value = '';
  if (customThickness) customThickness.innerHTML = '';

  if (document.querySelectorAll(hideElements).length > 0) {
    document.querySelectorAll(hideElements).forEach(function (e) {
      e.classList.remove('hide');
      e.classList.add('display');
    });
  }

  if (document.querySelectorAll(displayElements).length > 0) {
    document.querySelectorAll(displayElements).forEach(function (e) {
      e.classList.remove('display');
      e.classList.add('hide');
    });
  }

  var productVariants = window.productVariants;
  var inputs = document.querySelectorAll('#variant-selectors input[type="radio"]');

  const customSizeEl = document.querySelector('.custom-size');
  if (customSizeEl) customSizeEl.classList.remove('active');

  const selectedInputs = Array.from(document.querySelectorAll('#variant-selectors label')).map(fieldset => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  });

  const selectedOptions = Array.from(
    document.querySelectorAll('#variant-selectors #dimensions-dropdown select')
  ).map(select => select.value);

  var options = [];
  selectedInputs.forEach(function (value) {
    if (value) options.push(value);
  });
  options.push(selectedOptions[0]);

  function findVariant(options) {
    var joined = options.join(' / ');
    var selected = '';
    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];
      if (joined == variant.public_title) {
        selected = variant;
        break;
      }
    }
    return selected;
  }

  var finalVariant = findVariant(options);

  /* ── Active state — hamesha update karo ── */
  document.querySelectorAll('.variantSelector').forEach(function (element) {
    element.classList.remove('active');
  });
  inputs.forEach(function (element) {
    if (element.checked === true) {
      element.parentElement.classList.add('active');
    }
  });

  if (finalVariant) {
    /* ── Price HTML — ₹ + MRP div structure ── */
    var priceFormatted = Shopify.formatMoney(finalVariant.price, "₹{{amount}}");
    var off = '';
    var priceHTML = priceFormatted + '<div class="mrp-desktop">MRP</div>';

    if (finalVariant.compare_at_price && finalVariant.compare_at_price > finalVariant.price) {
      var compareFormatted = Shopify.formatMoney(finalVariant.compare_at_price, "₹{{amount}}");
      priceHTML += '<span>' + compareFormatted + '</span>';
      off = calculatePercentageOff(finalVariant.compare_at_price / 100, finalVariant.price / 100);
    }

    /* ── Page price update ── */
    document.querySelector('#pdpPrice').innerHTML = priceHTML;

    /* ── Page percentage off update ── */
    document.querySelectorAll('#PdpPercentageOff').forEach(function (el) {
      el.innerHTML = off ? '(' + off + ')' : '';
    });

    /* ── Popup price update ── */
    var popupPriceLeft = document.querySelector('.product-form-popup .popupPrice .product-price-left');
    var popupPercentageOff = document.querySelector('.product-form-popup .popupPrice .product-price-off');

    if (popupPriceLeft) {
      popupPriceLeft.innerHTML = priceHTML;
    }
    if (popupPercentageOff) {
      popupPercentageOff.innerHTML = off ? '(' + off + ')' : '';
      popupPercentageOff.style.display = off ? '' : 'none';
    }

    document.querySelector('#pdp-main-variant').value = finalVariant.id;

    document.querySelectorAll('.product-size-text').forEach(function (e) {
      let option1 = finalVariant.options[0] || '';
      let option2 = finalVariant.options[1] || '';
      let option3 = finalVariant.options[2] || '';

      let thicknessInch = option2.replace(/"/g, '').trim();
      let thicknessCm = '';

      if (thicknessInch) {
        if (thicknessInch.includes('+')) {
          let parts = thicknessInch.split('+').map(p => parseFloat(p.trim()));
          let totalInch = parts.reduce((a, b) => a + (isNaN(b) ? 0 : b), 0);
          thicknessCm = Math.round(totalInch * 2.54);
          thicknessInch = totalInch.toString();
        } else if (!isNaN(thicknessInch)) {
          thicknessCm = Math.round(parseFloat(thicknessInch) * 2.54);
        }
      }

      let inchDim = '';
      let cmDim = '';
      if (option3 && option3.toLowerCase().includes('x')) {
        let dims = option3.replace(/"/g, '').split(/x|X/).map(d => d.trim());
        if (dims.length === 2) {
          let cm1 = Math.round(parseFloat(dims[0]) * 2.54);
          let cm2 = Math.round(parseFloat(dims[1]) * 2.54);
          inchDim = `${dims[0]}" x ${dims[1]}"`;
          cmDim = `${cm1} cm x ${cm2} cm`;
        }
      }

      let inchPart = `${option1}`;
      if (option2) inchPart += ` . ${option2}"`;
      if (inchDim) inchPart += ` . ${inchDim}`;

      let cmPart = '';
      if (thicknessCm && cmDim) {
        cmPart = `${thicknessCm} cm, ${cmDim}`;
      }

      e.innerHTML = `<span class="inch">${inchPart.replace(/\./g, ' | ')}</span><span class="centimeter">  (${cmPart})</span>`;
    });

    history.pushState({}, '', `/products/${handle}?variant=${finalVariant.id}`);

  } else {
    var pdpVariantTitle = document.querySelector('#pdpVariantTitle');
    if (pdpVariantTitle) pdpVariantTitle.innerHTML = '';
    document.querySelector('#pdp-main-variant').value = '';
    document.querySelectorAll('#PdpPercentageOff').forEach(function (el) {
      el.innerHTML = '';
    });
    document.querySelector('#pdpPrice').innerHTML = 'Out of stock';
    var inclusiveTax = document.querySelector('.inclusive-tax');
    if (inclusiveTax) inclusiveTax.innerHTML = '';
  }
}

function calculatePercentageOff(mrp, salePrice) {
  if (mrp <= 0) return '';
  const percentageOff = ((mrp - salePrice) / mrp) * 100;
  if (percentageOff > 0) {
    return percentageOff.toFixed(0) + '% off';
  }
}

var header = document.querySelector(".header");
var navbarHeight = header.offsetHeight;
var lastScrollTop = 0;

window.onscroll = function () { scrollHide(); };

function scrollHide() {
  var st = window.pageYOffset || document.documentElement.scrollTop;
  console.log(st);
  if (st > lastScrollTop) {
    header.classList.add('hide');
  } else {
    header.classList.remove('hide');
  }
  lastScrollTop = st <= 0 ? 0 : st;
}

/* ── Close PDP popup on add-to-cart ── */
(function () {
  function hidePopup() {
    document.querySelectorAll('.product-form-popup').forEach(function (p) {
      p.style.display = 'none';
      p.classList.remove('active');
    });
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest('.product-form-popup')) {
      setTimeout(hidePopup, 400);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.product-form-popup button[type="submit"], .product-form-popup input[type="submit"]')) {
      setTimeout(hidePopup, 400);
    }
  }, true);

  if (!window.__closePopupFetchPatched) {
    window.__closePopupFetchPatched = true;
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      var p = _fetch.apply(this, args);
      if (url && url.indexOf('/cart/add') !== -1) {
        p.then(function () { setTimeout(hidePopup, 400); })
          .catch(function () { });
      }
      return p;
    };
  }
})();